import Input from './input';

export default Input;